module.exports = __webpack_public_path__ + "img/img37.7655bad3.svg";